(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".membership-banner__button").forEach((button) => {
      button.addEventListener("mouseenter", () => {
        button.style.transform = "translateY(-3px)";
      });
      button.addEventListener("mouseleave", () => {
        button.style.transform = "translateY(0)";
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-testimonial-slider]").forEach((slider) => {
      const section = slider.closest(".testimonial-section");
      if (!section) return;
      const isMobileEnabled = section.dataset.mobileSlider === "true";
      
      if (isMobileEnabled && window.innerWidth <= 749) {
        let autoplayInterval;
        let currentIndex = 0;
        const cards = slider.querySelectorAll(".testimonial-card");
        const totalCards = cards.length;

        // Auto-play function
        const startAutoplay = () => {
          autoplayInterval = setInterval(() => {
            currentIndex = (currentIndex + 1) % totalCards;
            const card = cards[currentIndex];
            if (card) {
              slider.scrollTo({ left: card.offsetLeft - 20, behavior: 'smooth' });
            }
          }, 4000); // 4 seconds interval
        };

        // Stop autoplay on manual interaction
        slider.addEventListener('touchstart', () => clearInterval(autoplayInterval));
        slider.addEventListener('mousedown', () => clearInterval(autoplayInterval));

        // Start autoplay
        startAutoplay();

        // Drag to scroll
        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;

        slider.addEventListener("mousedown", (e) => {
          isDown = true;
          slider.classList.add("is-dragging");
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener("mouseleave", () => { isDown = false; slider.classList.remove("is-dragging"); });
        slider.addEventListener("mouseup", () => { isDown = false; slider.classList.remove("is-dragging"); });

        slider.addEventListener("mousemove", (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * 1.5;
          slider.scrollLeft = scrollLeft - walk;
        });

        let touchStart = 0;
        slider.addEventListener("touchstart", (e) => { touchStart = e.touches[0].clientX; });
        slider.addEventListener("touchmove", (e) => {
          const touchMove = e.touches[0].clientX;
          slider.scrollLeft += touchStart - touchMove;
          touchStart = touchMove;
        });

        // Navigation Arrows
        const prevBtn = section.querySelector(".testimonial-prev");
        const nextBtn = section.querySelector(".testimonial-next");

        if (prevBtn) {
          prevBtn.addEventListener("click", () => {
            clearInterval(autoplayInterval);
            slider.scrollBy({ left: -slider.offsetWidth * 0.88, behavior: 'smooth' });
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener("click", () => {
            clearInterval(autoplayInterval);
            slider.scrollBy({ left: slider.offsetWidth * 0.88, behavior: 'smooth' });
          });
        }
      }
    });
  });

  // Equal height for desktop
  function testimonialEqualHeight() {
    if (window.innerWidth < 750) return;
    document.querySelectorAll("[data-testimonial-slider]").forEach((grid) => {
      let height = 0;
      const cards = grid.querySelectorAll(".testimonial-card");
      cards.forEach((card) => { card.style.minHeight = ""; });
      cards.forEach((card) => { height = Math.max(height, card.offsetHeight); });
      cards.forEach((card) => { card.style.minHeight = height + "px"; });
    });
  }

  window.addEventListener("load", testimonialEqualHeight);
  window.addEventListener("resize", testimonialEqualHeight);

  } catch(e) { console.error(e); }
})();
})();
